(function () {
  class RespinsPopup extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._darkOverlay = resourceManager.get("respinsPopupContainer:respinsPopup:darkOverlay");
      this._backer = resourceManager.get("respinsPopupContainer:respinsPopup:backer");
      this._text = resourceManager.get("respinsPopupContainer:respinsPopup:text");
    }

    showPopup(callback) {
      this.visible = true;

      this._darkOverlay.alpha = 0;
      this._backer.scale.x = 0;
      this._backer.scale.y = 0;
      this._backer.rotation = 0;
      this._backer.alpha = 0;
      this._text.scale.x = 0;
      this._text.scale.y = 0;
      this._text.alpha = 0;

      const duration = 1.2;
      const delay = 0.3;

      gsap.to(this._darkOverlay, {
        duration: 0.5,
        delay,
        alpha: 0.6,
        onStart: () => {
          soundManager.play("respin");
        },
      });

      gsap.to(this._backer, {
        duration: duration * 3,
        delay,
        rotation: Math.PI * 6,
      });

      gsap
        .timeline()
        .to([this._backer, this._text], {
          duration: 0.6,
          delay,
          alpha: 1,
          ease: "power3.in",
        })
        .to(
          [this._backer.scale, this._text.scale],
          {
            duration,
            x: 1,
            y: 1,
            ease: "power3.inOut",
            repeat: 1,
            yoyo: true,
          },
          "<"
        )
        .to(
          [this._backer, this._text, this._darkOverlay],
          {
            duration: 0.3,
            alpha: 0,
          },
          ">-0.6"
        )
        .call(() => {
          callback();
        });
    }
  }

  let respinsPopupCreator = function (json) {
    return new RespinsPopup();
  };

  let respinsPopupInitialiser = function (json) {};

  let respinsPopupFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "respinsPopup",
    respinsPopupCreator,
    respinsPopupInitialiser,
    respinsPopupFilesRequired
  );
})();
